import "./about.css";
import { Helmet } from "react-helmet-async";
import Path from "../../components/path/path";
import { useEffect } from "react";

const About = ({ Data }) => {
  const AboutData = Data.About;

  useEffect(() => {
    const $employees = window.$("#employees");
    $employees.owlCarousel({
      navigation: true,
      items: 3,
      itemsCustom: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: false,
      itemsMobile: [479, 1],
    });
    return () => {
      $employees.trigger("destroy.owl.carousel");
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Think Twice Second Hand Clothes | About Us</title>
        <meta name="description" content="Think Twice provides quality second-hand fashion at affordable prices. Join us in the circular economy and fight climate change through sustainable fashion." />
      </Helmet>
      <div id="about">
        <section className="ourStory">
          <div className="container">
            <Path pathName={"About"} />
            <div className="row mx-2 mt-4">
              <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
                <div>
                  <h1>Who We Are</h1>
                  <div className="mt-4 ms-2 ms-lg-0">
                    <p>
                      <strong>Think Twice</strong> provides its customers with great fashion at an affordable price, 
                      enabling people to re-use and give new life to clothes. We are proud to give people the 
                      opportunity to buy quality and stylish clothes that don't break the bank.
                    </p>
                    <p className="mt-4">
                      Based in Kenya, we serve customers across the country with a curated selection of 
                      second-hand clothing. Every piece is carefully selected to ensure quality, style, and value. 
                      When you shop with us, you're not just getting great fashion—you're making a positive impact 
                      on the environment.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 mt-3 mt-lg-0">
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    src="assets/images/about/ourStory.png"
                    alt="Think Twice Second Hand Clothes"
                    width="100%"
                  />
                </div>
              </div>
            </div>

            {/* Vision Section */}
            <div className="row mx-2 mt-5 pt-5">
              <div className="col-12 col-lg-6 order-lg-2 d-flex justify-content-center align-items-center">
                <div>
                  <h1>Our Vision</h1>
                  <div className="mt-4 ms-2 ms-lg-0">
                    <p>
                      We aim to be at the forefront of the <strong>circular economy model</strong> by enabling 
                      the re-use of second-hand clothes. In doing so, we lower carbon emissions and assist in 
                      the fight against climate change.
                    </p>
                    <p className="mt-4">
                      The re-use of clothes also helps to mitigate other environmental concerns by reducing 
                      excessive consumption of brand new clothes that cause an additional strain on resources. 
                      Every garment you buy from us is one less item in a landfill and one less new item that 
                      needs to be produced.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 order-lg-1 mt-3 mt-lg-0">
                <div className="vision-highlights">
                  <div className="highlight-card">
                    <div className="highlight-icon">🌍</div>
                    <h3>Sustainable Fashion</h3>
                    <p>Reduce carbon footprint through clothing reuse</p>
                  </div>
                  <div className="highlight-card">
                    <div className="highlight-icon">♻️</div>
                    <h3>Circular Economy</h3>
                    <p>Give clothes a second life, reduce waste</p>
                  </div>
                  <div className="highlight-card">
                    <div className="highlight-icon">💚</div>
                    <h3>Environmental Impact</h3>
                    <p>Lower resource consumption, fight climate change</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Why Choose Us */}
            <div className="row mx-2 mt-5 pt-5">
              <div className="col-12 text-center mb-4">
                <h1>Why Choose Think Twice?</h1>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">👕</div>
                  <h3>Quality Selection</h3>
                  <p>Every item is carefully inspected and curated for quality and style</p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">💰</div>
                  <h3>Affordable Prices</h3>
                  <p>Great fashion doesn't have to be expensive. Save money while looking good</p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">🚚</div>
                  <h3>Fast Delivery</h3>
                  <p>Nationwide delivery within 2-3 business days across Kenya</p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">🌱</div>
                  <h3>Eco-Friendly</h3>
                  <p>Make a positive environmental impact with every purchase</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="results">
          <div className="container">
            <div className="row mx-5">
              {AboutData.result.map((item) => (
                <div
                  key={item.resultId}
                  className="col-12 col-lg-3 d-flex justify-content-center my-2 my-lg-0 "
                >
                  <div className="resultBox text-center py-3">
                    <div className="d-flex justify-content-center my-2">
                      <div className="resultBoxIcon d-flex justify-content-center align-items-center">
                        <span className="resultBoxIconDeeb d-flex justify-content-center align-items-center">
                          <i className={item.resultIcon}></i>
                        </span>
                      </div>
                    </div>
                    <h3 className="m-0">{item.resultNumper}</h3>
                    <span>{item.resultTitle}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-cta">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2>Ready to Think Twice?</h2>
                <p>Join us in making fashion sustainable and affordable</p>
                <div className="cta-buttons">
                  <a href="/home" className="btn-primary">Shop Now</a>
                  <a href="/contact" className="btn-secondary">Contact Us</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="employees">
          <div className="container">
            <div className="row mx-2">
              <div className="col-12">
                <div id="employees" className="owl-carousel owl-theme">
                  {AboutData.employees.map((item) => (
                    <div key={item.employeId} className="item mx-4">
                      <div className="card">
                        <div className="card-img-top pt-2 d-flex justify-content-center">
                          <img src={item.employeImg} alt="..." width="90%" />
                        </div>
                        <div className="card-body p-0 my-3">
                          <h2 className="card-title">{item.employeName}</h2>
                          <p className="card-text">{item.employeJob}</p>
                          <p className="card-text">
                            <div>
                              <a href={item.employesocialMediaLink.twitter}>
                                <i className="bi bi-twitter mx-2"></i>
                              </a>
                              <a href={item.employesocialMediaLink.instagram}>
                                <i className="bi bi-instagram mx-2"></i>
                              </a>
                              <a href={item.employesocialMediaLink.linkedIn}>
                                <i className="bi bi-linkedin m-2"></i>
                              </a>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
